"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _ArrowItem = _interopRequireDefault(require("./components/ArrowItem/ArrowItem"));

var _CurrentPageItem = _interopRequireDefault(require("./components/CurrentPageItem/CurrentPageItem"));

var _ElipsisItem = _interopRequireDefault(require("./components/EllipsisItem/ElipsisItem"));

var _PageItem = _interopRequireDefault(require("./components/PageItem/PageItem"));

var sc = _interopRequireWildcard(require("./Pagination.styles"));

var _excluded = ["currentPage", "totalPages", "size", "onChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isCurrentPage = function isCurrentPage(pageNumber, currentPage) {
  return currentPage === pageNumber;
};

var isFirstPage = function isFirstPage(pageNumber) {
  return pageNumber === 1;
};

var isLastPage = function isLastPage(pageNumber, totalPages) {
  return pageNumber === totalPages;
};

var isNotEllipsed = function isNotEllipsed(pageNumber, left, right, totalPages) {
  return pageNumber === 2 && left === 3 || pageNumber === totalPages - 1 && right === totalPages - 2;
};

var isRenderableSibling = function isRenderableSibling(pageNumber, left, right) {
  return left <= pageNumber && pageNumber <= right;
};

var renderPageElements = function renderPageElements(currentPage, totalPages, size, onChange) {
  var pagesOnEachSideSize = {
    small: 1,
    medium: 2,
    large: 3
  };
  var left = currentPage - pagesOnEachSideSize[size];
  var right = currentPage + pagesOnEachSideSize[size];
  var items = [];
  var wasPreviousItemEllipsized = false;

  var _loop = function _loop(pageNumber) {
    if (isCurrentPage(pageNumber, currentPage)) {
      items.push( /*#__PURE__*/_react["default"].createElement(_CurrentPageItem["default"], {
        key: pageNumber,
        pageNumber: pageNumber
      }));
    } else if (isFirstPage(pageNumber) || isLastPage(pageNumber, totalPages) || isRenderableSibling(pageNumber, left, right) || isNotEllipsed(pageNumber, left, right)) {
      items.push( /*#__PURE__*/_react["default"].createElement(_PageItem["default"], {
        key: pageNumber,
        onClick: function onClick() {
          onChange(pageNumber);
        },
        pageNumber: pageNumber
      }));
      wasPreviousItemEllipsized = false;
    } else if (!wasPreviousItemEllipsized) {
      items.push( /*#__PURE__*/_react["default"].createElement(_ElipsisItem["default"], {
        key: pageNumber
      }));
      wasPreviousItemEllipsized = true;
    }
  };

  for (var pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
    _loop(pageNumber);
  }

  return items;
};

function Pagination(props) {
  var currentPage = props.currentPage,
      totalPages = props.totalPages,
      size = props.size,
      onChange = props.onChange,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(sc.Pagination, (0, _extends2["default"])({
    "data-pka-anchor": "pagination"
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_ArrowItem["default"], {
    isDisabled: currentPage === 1,
    onClick: function onClick() {
      onChange(currentPage - 1);
    },
    type: "Left"
  }), renderPageElements(currentPage, totalPages, size, onChange), /*#__PURE__*/_react["default"].createElement(_ArrowItem["default"], {
    isDisabled: currentPage === totalPages,
    onClick: function onClick() {
      onChange(currentPage + 1);
    },
    type: "Right"
  }));
}

Pagination.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** The number of current active page */
  currentPage: _propTypes["default"].number.isRequired,

  /** Callback to be executed when current page is changed. */
  onChange: _propTypes["default"].func,

  /** The number of other pages that will be visible around the current/active page (not hidden by elipsis). Can be set to small, medium, or large */
  size: _propTypes["default"].PropTypes.oneOf([Pagination.types.size.SMALL, Pagination.types.size.MEDIUM, Pagination.types.size.LARGE]),

  /** The number of total pages. */
  totalPages: _propTypes["default"].number.isRequired
};
var defaultProps = {
  onChange: function onChange() {},
  size: Pagination.types.size.MEDIUM
};
Pagination.displayName = "Pagination";
Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
var _default = Pagination;
exports["default"] = _default;
//# sourceMappingURL=Pagination.js.map